import { Grid, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import style from "../riepilogoDialogDelete.module.css";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import AvatarImage from "../../../Avatar/AvatarImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoPostazione from "./InfoPostazione";


export function BodyRiepilogoDelete({ data }) {
  const { t } = useTranslation();
  
  return Object.values(data).map((utente) => {
    const { idUtente, nomeUtente, postazioni } = utente;
    const primaPrenotazione = postazioni.flatMap((p) => [...p.cancellate, ...p.fallite])[0];

    return (
      postazioni.length === 0 ? (
        <Typography>{t("no_reservation_deleted")}</Typography>
      ) : (
        <Paper
          key={idUtente}
          className={`${style["paper-DialogRiepilogo"]} ${style["box-shadow-light-paper-Riepilogo"]}`}
        >
          <Grid container item xs={12} spacing={2}>

            {/* Header utente */}
            <Grid item xs={12} className={style["no-padding-top"]}>
              <Typography className={style["field-DialogRiepilogo"]}>
                <div className={`${style["flex-center"]} ${style["line-spacing"]}`}>
                  <AvatarImage
                    ImmagineAvatar={primaPrenotazione.immagineAvatar}
                    isOspite={primaPrenotazione.ospite}
                    name={nomeUtente}
                    isInputDisabled={true}
                  />
                  <div className="padding-left-fullnameUtente">{nomeUtente}</div>
                </div>
              </Typography>
            </Grid>

            {/* Una sezione per ogni postazione */}
            {postazioni.map((postazione) => {
              const tutteLePrenotazioni = [
                ...postazione.cancellate.map((p) => ({ ...p, success: true })),
                ...postazione.fallite.map((p) => ({ ...p, success: false })),
              ].sort((a, b) =>
                moment(a.dataInizioPrenotazione).diff(moment(b.dataInizioPrenotazione))
              );

              const prima = tutteLePrenotazioni[0];
              if (!prima) return null;

              return (
                <Grid
                  container
                  item
                  xs={12}
                  key={postazione.idPostazione}
                  className={style["no-padding-top"]}
                >
                  {/* Info postazione */}
                  <Grid item xs={12} className={style["no-padding-top"]}>
                    <InfoPostazione
                      numerazionePostazione={prima.postazionePosto}
                      tipologiaStanza={prima.tipologiaStanza}
                      denominazioneZona={prima.zonaDenominazione}
                      denominazioneEdificio={prima.edificioDenominazione}
                      denominazioneStanza={prima.stanzaDenominazione}
                    />
                  </Grid>

                  {/* Lista prenotazioni della postazione */}
                  {tutteLePrenotazioni.map((prenotazione, index) => (
                    <Grid
                      container
                      item
                      xs={12}
                      key={`${prenotazione.id}-${index}`}
                      className={style["no-padding-top"]}
                    >
                      <Grid item xs={12} className={style["no-padding-top"]}>
                        <Typography className={style["field-DialogRiepilogo"]}>
                          <div className={`${style["flex-center"]} ${style["line-spacing"]}`}>
                            <div style={{ minWidth: "20px" }}>
                              {prenotazione.success ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className={`${style["icon-success"]} ${style["icon-spacing-right"]}`}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faXmark}
                                  className={`${style["icon-error"]} ${style["icon-spacing-right"]}`}
                                />
                              )}
                            </div>
                            <span>
                              {moment(prenotazione.dataInizioPrenotazione).format("DD/MM/YYYY")}{" "}
                              {moment(prenotazione.dataInizioPrenotazione).format("HH:mm")}{" "}
                              -{" "}
                              {moment(prenotazione.dataFinePrenotazione).format("HH:mm")}
                            </span>
                            {prenotazione.nominativoOspite && (
                              <span style={{ marginLeft: "8px", fontStyle: "italic" }}>
                                ({t("guest")}: {prenotazione.nominativoOspite})
                              </span>
                            )}
                          </div>
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              );
            })}
          </Grid>
        </Paper>
      ));
  });
}